import BaseController from "confinus_ui/base_controller";

export default class CatalogTypeSelectorController extends BaseController {
  static targets = [
    "newPanel",
    "duplicatePanel",
    "dependentPanel",
    "modifierFields",
  ];
  static values = { selectedCategory: { type: String, default: "new" } };

  declare readonly newPanelTarget: HTMLElement;
  declare readonly duplicatePanelTarget: HTMLElement;
  declare readonly dependentPanelTarget: HTMLElement;
  declare readonly hasModifierFieldsTarget: boolean;
  declare readonly modifierFieldsTarget: HTMLElement;
  declare selectedCategoryValue: string;

  connect(): void {
    super.connect();
    // Ensure hidden inputs in inactive panels are disabled on initial render,
    // otherwise the form submits stale type=clone / type=derived_follows values
    // alongside the real type radio and the last one wins.
    this.updatePanels();
  }

  selectCategory(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.checked) {
      this.selectedCategoryValue = input.value;
      this.updatePanels();
    }
  }

  toggleModifier(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;

    if (this.hasModifierFieldsTarget) {
      this.modifierFieldsTarget.classList.toggle("hidden", !checked);
    }

    // Switch type between derived_follows and derived_modifies
    const hiddenType = this.element.querySelector(
      '[data-field="catalog-type-derived"]',
    ) as HTMLInputElement | null;
    if (hiddenType) {
      hiddenType.value = checked ? "derived_modifies" : "derived_follows";
    }

    this.syncParentCatalog();
  }

  private syncParentCatalog(): void {
    const following = this.element.querySelector(
      '[name$="[following_catalog_id]"]',
    ) as HTMLSelectElement | null;
    const parent = this.element.querySelector(
      '[data-field="parent-catalog-id"]',
    ) as HTMLInputElement | null;
    if (following && parent) {
      parent.value = following.value;
    }
  }

  private updatePanels(): void {
    const panels: Record<string, HTMLElement> = {
      new: this.newPanelTarget,
      duplicate: this.duplicatePanelTarget,
      dependent: this.dependentPanelTarget,
    };

    Object.entries(panels).forEach(([category, panel]) => {
      const isActive = category === this.selectedCategoryValue;
      panel.classList.toggle("hidden", !isActive);

      panel
        .querySelectorAll<
          HTMLInputElement | HTMLSelectElement
        >("input[type=hidden], select")
        .forEach((input) => {
          input.disabled = !isActive;
        });
    });
  }
}
